import React, { createContext, useContext, useState } from 'react';
import InteractiveBackground from '@/components/ui/InteractiveBackground';
import { HeroDependencyField } from '@/components/visualizations/HeroDependencyField';

const WorldContext = createContext(null);
const rememberedLens = () => {
  try { return sessionStorage.getItem('gol-field-lens') === 'FINANCIAL' ? 'FINANCIAL' : 'ECOLOGICAL'; }
  catch (_) { return 'ECOLOGICAL'; }
};

export const FilmWorld = ({ className = '', children, ...props }) => {
  const [mode, setMode] = useState(rememberedLens);
  const changeLens = () => {
    setMode(current => {
      const next = current === 'ECOLOGICAL' ? 'FINANCIAL' : 'ECOLOGICAL';
      try { sessionStorage.setItem('gol-field-lens', next); } catch (_) { /* Storage is optional. */ }
      return next;
    });
  };
  return <WorldContext.Provider value={{ mode, changeLens }}>
    <div className={`film-world ${className}`} data-perspective={mode} {...props}>
      <InteractiveBackground viewMode={mode} density={0.9} />
      {children}
    </div>
  </WorldContext.Provider>;
};

export const FilmLens = () => {
  const { mode, changeLens } = useContext(WorldContext);
  return <div className="film-lens" data-testid="film-perspective-control">
    <span className={mode === 'ECOLOGICAL' ? 'is-active' : ''}>Biocomplexity</span>
    <button type="button" role="switch" aria-label="Capital perspective" aria-checked={mode === 'FINANCIAL'} data-testid="field-perspective-toggle" onClick={changeLens}><span /></button>
    <span className={mode === 'FINANCIAL' ? 'is-active' : ''}>Capital</span>
  </div>;
};

export const FilmContours = () => {
  const { mode } = useContext(WorldContext);
  return <div className="film-contours" aria-hidden="true"><HeroDependencyField mode={mode} /></div>;
};